import React, { useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import styles from './CodeVerification.module.css';

interface Props {
  codeLength: number;
  onChange: (code: string) => void;
  loading: boolean;
  isError: boolean;
}

const CodeVerification = ({
  codeLength,
  onChange,
  loading,
  isError,
}: Props): JSX.Element => {
  const [code, setCode] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);
  const buttonsRef = useRef<HTMLDivElement>(null);

  const focusInput = () => inputRef.current?.focus();

  useEffect(() => {
    if (isError && inputRef.current) {
      focusInput();
    }
  }, [inputRef.current, isError]);

  const onChangeCode = (value: string) => {
    const currentCode = value.replace(/[^0-9]/g, '');
    setCode(currentCode);

    if (currentCode.length === codeLength) {
      onChange(currentCode);
      setCode('');
    }
  };

  return (
    <React.Fragment>
      <div ref={buttonsRef} className={styles.codeVerification}>
        {[...Array(codeLength)].map((digit, index) => (
          <button
            className={cn(styles.codeVerification__code, {
              [styles.codeVerification__code_active]: index === code.length,
            })}
            key={index}
            onClick={focusInput}
          >
            {code[index]}
          </button>
        ))}
      </div>

      <input
        className={styles.codeVerification_hidden}
        ref={inputRef}
        value={code}
        onChange={(e) => onChangeCode(e.target.value)}
        onBlur={focusInput}
        type={'number'}
        maxLength={length}
        autoFocus={true}
        disabled={loading}
      />
    </React.Fragment>
  );
};

export default CodeVerification;
